import { LogIn, Link2, ScanText, Palette } from "lucide-react";

// Scripted demo runs so the side panel feels alive without a backend.
// Each scenario mirrors the real `TestRunResult` shape: steps, a verdict,
// an optional bug, plus token/cost so the cost-chip is always honest.

export const CHIPS = [
  { id: "login", label: "Test login", icon: LogIn },
  { id: "links", label: "Check all links", icon: Link2 },
  { id: "content", label: "Scan content", icon: ScanText },
  { id: "ui", label: "Critique UI", icon: Palette },
];

export const SCENARIOS = {
  login: {
    instruction: "Log in with a wrong password and check the error shows.",
    steps: [
      "Navigate to /login",
      "Fill email field",
      "Fill password field",
      "Click “Sign in”",
      "Assert error message is visible",
    ],
    failIndex: 4,
    verdict: "FAILED",
    duration: "18s",
    cost: "$0.004",
    tokens: "1,240",
    bug: {
      title: "No error shown on invalid login",
      severity: "high",
      expected: "An error message appears for wrong credentials.",
      actual: "The page stayed blank and no message was shown.",
      repro: [
        "Open /login",
        "Enter a valid email with a wrong password",
        "Click “Sign in”",
      ],
    },
  },
  links: {
    instruction: "Check all links on the page work.",
    steps: [
      "Navigate to the page",
      "Collect all anchor links",
      "Request each link",
      "Assert no broken links",
    ],
    verdict: "PASSED",
    duration: "11s",
    cost: "$0.002",
    tokens: "610",
    note: "24 links checked — all returned 200 OK.",
  },
  content: {
    instruction: "Scan the page for downloadable files.",
    steps: [
      "Navigate to the page",
      "Scan the DOM for file links",
      "Assert findings",
    ],
    verdict: "PASSED",
    duration: "7s",
    cost: "$0.001",
    tokens: "340",
    note: "No downloadable files found on this page.",
  },
  ui: {
    instruction: "Critique the UI for obvious issues.",
    steps: [
      "Navigate to the page",
      "Capture a page snapshot",
      "Analyze layout & contrast",
      "Summarize findings",
    ],
    verdict: "PASSED",
    duration: "14s",
    cost: "$0.003",
    tokens: "980",
    note: "3 minor suggestions noted (contrast on footer links, button spacing).",
  },
  default: {
    instruction: "",
    steps: [
      "Navigate to the page",
      "Interpret the instruction",
      "Execute the steps",
      "Assert the expected outcome",
    ],
    verdict: "PASSED",
    duration: "9s",
    cost: "$0.003",
    tokens: "720",
    note: "Looks good — the expected outcome was met.",
  },
};

export function getScenario(id, instruction) {
  const base = SCENARIOS[id] || SCENARIOS.default;
  return { ...base, instruction: instruction || base.instruction };
}
